const SEP = { id: { g: ".", d: "," }, en: { g: ",", d: "." }, zh: { g: ",", d: "." } };
export const sepOf = (lang) => SEP[lang] || SEP.id;
export const group = (s, g) => s.replace(/\B(?=(\d{3})+(?!\d))/g, g);

// 1234567.5 -> "1.234.567,50" (id) / "1,234,567.50" (en, zh): always 2 decimals.
export function fmtAmount(v, lang) {
  const n = Number(v || 0);
  const { g, d } = sepOf(lang);
  const [i, f] = Math.abs(n).toFixed(2).split(".");
  return `${n < 0 ? "-" : ""}${group(i, g)}${d}${f}`;
}
export const fmtRp = (v, lang) => `Rp ${fmtAmount(v, lang)}`;

// App language for formatters used outside components (reports, exports); kept in sync by I18nProvider.
let current = "id";
export const setNumLang = (l) => { current = l; };
export const numLang = () => current;
export const fmt2 = (v) => fmtAmount(v, current);
export const numLocale = () => (current === "id" ? "id-ID" : "en-US");
